import { FETCH_STUDENT_GOALS, SAVE_STUDENT_GOAL } from '../../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../../actionCreators';

export const fetchStudentGoalsShared = (config, client) => async (dispatch, getState) => {
    const state = getState();
    const { selectors } = config.root;
    const { studentIds, year: schoolYear } = selectors.getCommonData(state);
    const additionalApiParams = {
        apiParams: [studentIds, schoolYear],
    };
    await apiActionCreator(
        dispatch,
        FETCH_STUDENT_GOALS,
        client.getStudentGoals,
        additionalApiParams,
    );
};

export const saveStudentGoalShared = (goal, config, client) => async (dispatch, getState) => {
    const state = getState();
    const { selectors } = config.root;
    const { userId: staffId } = selectors.getCommonData(state);
    const additionalApiParams = {
        apiParams: [goal, staffId],
    };
    await apiActionCreator(
        dispatch,
        SAVE_STUDENT_GOAL,
        client.saveStudentGoal,
        additionalApiParams,
    );
};
